<template>
	<div class="content">

		<div class="md-layout">
			<div class="md-layout-item md-medium-size-30 md-size-30 md-small-size-0">
			</div>
			<div class="md-layout-item md-medium-size-40 md-size-40 md-small-size-100">

				<md-card>
					<md-card-header data-background-color="purple">

						<h4 class="title"><b>{{$store.state.locale.locale.status[$store.state.locale.lang]}}</b></h4>
					</md-card-header>
					<md-card-content>
						<div class="md-layout">
							<div class="md-layout-item md-small-size-100 md-size-100" style="text-align: center;">
								<h1>{{total}}</h1>
							</div>
						</div>
					</md-card-content>
				</md-card>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		components: {
		},
		data() {
			return {
				msg: false,
				code: "",
				total: 0,
				interval: null
			}
		},
		created() {
			this.realtime();
		},
		beforeDestroy() {
			clearInterval(this.interval);
		},
		methods: {
			realtime() {
				this.interval = setInterval(() => {
					this.$http.get(this.config.api + "/public/realtime").then(data => {
						this.total = data.body.data.total_current_checkin
					})
				}, 2000)
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/pages/Tracking.vue